import VueI18n from 'vue-i18n';

const messages = {
  en: {
    sensor: {
      place: 'Installation site',
    },
    station: {
      trap_no: 'Trap No',
      installed_at: 'Installed on',
      collected_at: 'Collected on',
      days: 'Days installed',
      month: 'Month',
      upload_time: 'Upload time',
      photo_count: 'Photo count',
      insect_count: 'Insect count',
      index: 'Index',
      locomotion: 'Trap type',
      locomotion_label: {
        flying: 'Flying',
        crawling: 'Crawling',
      },
      locomotion_filter: {
        all: 'All',
        label: 'Filter by trap type',
      },
    },
  },
  ja: {
    sensor: {
      place: '設置場所',
    },
    station: {
      trap_no: 'トラップNo',
      installed_at: '設置日',
      collected_at: '回収日',
      days: '設置日数',
      month: '月',
      upload_time: 'アップロード日時',
      photo_count: '画像数',
      insect_count: '総頭数',
      index: '指数',
      locomotion: 'トラップ種別',
      locomotion_label: {
        flying: 'ライト',
        crawling: '床置き',
      },
      locomotion_filter: {
        all: 'すべて',
        label: 'トラップ種別フィルタ',
      },
    },
  },
};

const i18n = new VueI18n({ locale: 'en', messages });

export default {
  computed: {
    term() {
      return key => i18n.t(key, this.$i18n.locale);
    },
  },
};
